module.exports = __webpack_public_path__ + "img/filters.0a1ed97a.svg";